export class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productURL = this.querySelector("a")?.href ?? null;
    this.badges = this.querySelector(".badges");
    this.isGraphene = this.hasAttribute("data-graphene");

    if (!this.productURL) return;

    this.init();
  }

  async init() {
    if (this.isGraphene) {
      await this.updateBadges();
    }
    this.setupSwatches();
    this.setupLoadMoreSwatches();
  }

  /** ---------- Fetch Helpers ---------- **/

  async fetchHTML(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
      const html = await response.text();
      return new DOMParser().parseFromString(html, "text/html");
    } catch (err) {
      console.error("Error fetching HTML:", err);
      return null;
    }
  }

  /** ---------- Product Updates ---------- **/

  async updateBadges() {
    const page = await this.fetchHTML(`${this.productURL}?view=product-badges`);
    this.replaceElement(".badges", page);
  }

  async updateProductDetails({ url, updateImages = false, updateDetails = false }) {
    let extension = "";
    const featuredImage = this.dataset.featuredImage;

    featuredImage != null && featuredImage == "flatlay"
      ? (extension = `?view=product-card-flatlay`)
      : (extension = `?view=product-card`);

    const page = await this.fetchHTML(url + extension);

    if (!page) return;

    if (updateImages) {
      this.replaceElement(".product-card__media", page);
    }

    if (updateDetails) {
      this.replaceElement(".compare-toggle", page);
      this.replaceElement(".price", page);
    }
  }

  replaceElement(selector, newDoc) {
    const current = this.querySelector(selector);
    const fresh = newDoc.querySelector(selector);
    if (current && fresh) current.replaceWith(fresh);
  }

  /** ---------- Swatches ---------- **/

  setupLoadMoreSwatches() {
    const plusIndicator = this.querySelector(".swatch-plus");
    const swatches = this.querySelectorAll(".swatches .swatch");

    if (!plusIndicator) return;

    plusIndicator.addEventListener("click", () => {
      swatches.forEach((swatch) => swatch.classList.remove("hidden"));
      plusIndicator.classList.add("hidden");
    });
  }

  setActiveSwatch(swatches, selected) {
    swatches.forEach((swatch) => swatch.querySelector("a")?.classList.remove("active"));
    selected.querySelector("a")?.classList.add("active");
  }

  setupSwatches() {
    const swatches = this.querySelectorAll(".swatches .swatch");
    if (!swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        event.preventDefault();
        const productUrl = swatch.querySelector("a")?.href.split("?")[0];
        if (!productUrl) return;

        this.updateProductDetails({
          url: productUrl,
          updateImages: true,
          updateDetails: true,
        });

        this.setActiveSwatch(swatches, swatch);
      });
    });
  }
}

customElements.define("product-card", ProductCard);
